import { render } from "./sys-dict.vue?vue&type=template&id=04de7581&scoped=true"
import script from "./sys-dict.vue?vue&type=script&lang=js"
export * from "./sys-dict.vue?vue&type=script&lang=js"

import "./sys-dict.vue?vue&type=style&index=0&id=04de7581&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04de7581"]])

export default __exports__